import { render } from "./UpdateSoundtrackPage.vue?vue&type=template&id=8c981942"
import script from "./UpdateSoundtrackPage.vue?vue&type=script&lang=js"
export * from "./UpdateSoundtrackPage.vue?vue&type=script&lang=js"

import "./UpdateSoundtrackPage.vue?vue&type=style&index=0&id=8c981942&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__